module.exports = __webpack_public_path__ + "img/Run.a8d52373.jpg";